var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotEnoughData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 374"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    cx: 16.043,
    cy: 15.9999,
    r: 11,
    transform: "rotate(-15.0843 16.043 15.9999)",
    stroke: "#787878",
    strokeWidth: 3,
    strokeDasharray: "6 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 38",
    d: "M13.1575 5.29481C10.3163 6.06058 7.89577 7.92362 6.42825 10.4741C4.96074 13.0246 4.5665 16.0535 5.33227 18.8947C6.09803 21.7358 7.96108 24.1564 10.5116 25.6239C10.5098 25.6173 10.5148 25.6359 10.5131 25.6296",
    stroke: "#787878",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotEnoughData);
export default __webpack_public_path__ + "static/media/NotEnoughData.b5f4c39f67ba879c6f2ffdcdf55960cb.svg";
export { ForwardRef as ReactComponent };